module.exports = __webpack_public_path__ + "static/variant-offer-modal-mobile-55ced9411e23172ef892ebeb4a25d0b2.png";